var LGFG = LGFG || {};
LGFG.CP = LGFG.CP || {};

LGFG.CP.CustomerSolutionsMap = LGFG.CP.CustomerSolutionsMap || (function () {

    // Define settings defaults
    var _settings = {};

    var init = function (settings) {

        // Override settings defaults if specified
        if (typeof (settings) !== 'undefined') {
            _settings = settings;
        }

        var mapSettings = {
            mapElementId: 'customer-solutions-map',
            mapConfigurationEndpoint: '/wfcustomersolutionsmap/getinitialmapconfiguration',
            mapMarkerEndpoint: '/wfcustomersolutionsmap/getresultsasmarkers',
            mapMarkerInfoWindowEndpoint: '/wfcustomersolutionsmap/getmarkerinfoview',
            mapMarkerListViewElementSelector: '#customer-solutions-list-results',
            mapMarkerListViewEndpoint: '/wfcustomersolutionsmap/getlistresultsview',
            mapMarkerListViewBeforeLoad: function () { },
            mapMarkerListViewAfterLoad: function () {
                $('#customer-solutions-list-results div[data-role="pager"] a').click(function (e) {
                    $('html,body').animate({ scrollTop: $('#results').offset().top }, 'slow');
                });
            },
            filterReloadsMapMarkers: true,
            filterPreventsMapMoveReload: false,
            minZoomForListResults: 0
        };
        var filterSettings = {
            textSearchElementSelector: '#customer-solutions-filter-query',
            textSearchSubmitElementSelector: '#customer-solutions-filter-query-submit',
            productTypeSelectorElementSelector: '#customer-solutions-filter-product-type',
            locationDropdownElementSelector: '#customer-solutions-filter-location',
            industryDropdownElementSelector: '#customer-solutions-filter-industry'
        };
        var filter = LGFG.CP.CustomerSolutionsMapFilter;
        LGFG.CP.Map.init(mapSettings, { filter: filter, filterSettings: filterSettings });
    };

    return {
        init: init
    };
})();